import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'agg-message-action',
    templateUrl: './agg-message-action.component.html',
    styleUrls: ['./agg-message-action.component.scss']
})
export class AggMessageActionComponent implements ICellRendererAngularComp {
    public params: any;

    agInit(params: any): void {
        this.params = params;
    }

    public invoke() {
        this.params.context.componentParent.openLink(this.params.data.id);
    }

    refresh(): boolean {
        return false;
    }
}